import React from 'react';
import { FaHome, FaMicrophone, FaChartBar, FaCogs, FaUserCog, FaTools, FaQuestionCircle, FaLifeRing, FaClipboardCheck, FaRobot, FaWaveSquare } from 'react-icons/fa';

const Sidebar = ({ selectedTab, onSelectTab, isVisible }) => {
  const menuItems = [
    { key: 'home', label: 'Home', icon: <FaHome /> },
    { key: 'clientsetup', label: 'Client Setup', icon: <FaUserCog /> },
    { key: 'clientscorecard', label: 'Client Scorecard', icon: <FaClipboardCheck /> },
    { key: 'prompts', label: 'Prompt Management', icon: <FaCogs /> },
    { key: 'transcribe', label: 'QA Prompt Evaluator', icon: <FaMicrophone /> },
    { key: 'dashboard', label: 'Dashboard', icon: <FaChartBar /> },
    { key: 'deepanalysis', label: 'Deep Analysis', icon: <FaChartBar /> },
    { key: 'configuration', label: 'Configuration', icon: <FaTools /> },
    { key: 'subscription', label: 'Subscription', icon: <FaClipboardCheck /> },
    { key: 'reports', label: 'Reports', icon: <FaChartBar /> },
    { key: 'help', label: 'Help', icon: <FaQuestionCircle /> },
    { key: 'support', label: 'Contact Us', icon: <FaLifeRing /> }
  ];

  const handleExternalLink = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div
      className={`bg-gray-900 text-white w-64 h-screen fixed flex flex-col justify-between z-40 transition-transform duration-300 ${
        isVisible ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      <div>
        <div className="flex justify-center p-4">
          <span className="text-xl font-bold text-center">Yaqeen GenAI QA Monitor™ 🌀</span>
        </div>

        <ul className="space-y-2 p-4">
          {menuItems.map((item) => (
            <li
              key={item.key}
              onClick={() => onSelectTab(item.key)}
              className={`p-2 rounded cursor-pointer flex items-center space-x-2 ${
                selectedTab === item.key ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </li>
          ))}

          {/* Spacer before external link */}
          <div className="mt-6" />

          {/* Auralytics™ - opens external URL */}
          <li
            onClick={() =>
              handleExternalLink('https://master.d10zkqsqvc0ab4.amplifyapp.com/app')
            }
            className="p-2 rounded cursor-pointer flex items-center space-x-2 hover:bg-gray-700"
          >
            <FaWaveSquare />
            <span>Auralytics™</span>
          </li>
        </ul>
      </div>

      {/* Bottom section: CoPilot + Copyright */}
      <div className="p-4">
        <li
          onClick={() => onSelectTab('copilot')}
          className="list-none bg-purple-600 text-white p-2 rounded cursor-pointer flex items-center space-x-2 shadow-lg animate-pulseGlow hover:bg-purple-700 transition duration-200 mb-4"
        >
          <FaRobot />
          <span className="font-semibold">CoPilot</span>
        </li>

        <div className="text-center text-xs text-gray-400 border-t border-gray-700 pt-3">
          © {new Date().getFullYear()} Yaqeen Technology. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default Sidebar;

